const styles = theme => ({
    parent: {
        marginTop: '-1px',
        position: 'relative'
    },
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        [theme.breakpoints.up(theme.breakpoints.values.xs + 1800)]: {
            maxWidth: '90%'
        },
        [theme.breakpoints.up(theme.breakpoints.values.xs + 2000)]: {
            maxWidth: '80%',
            justifyContent: 'center'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 920)]: {
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '0 1rem'
        }
    },
    imgWrap: {
        flexBasis: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginRight: '44px',
        marginLeft: '50px',
        marginTop: '-3rem',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
            marginLeft: '1rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 920)]: {
            flexDirection: 'column',
            justifyContent: 'center',
            margin: 0,
            marginBottom: '80px'
        }
    },
    img: {
        marginBottom: '-4px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 920)]: {
            width: '100%'
        }
    },
    textWrap: {
        flexBasis: '50%',
        width: '100%',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        flexDirection: 'column',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1250)]: {
            flexBasis: 'auto',
            paddingLeft: '1rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 920)]: {
            alignItems: 'flex-start',
            paddingLeft: 0,
            marginTop: '80px'
        }
    },
    h1: {
        fontFamily: 'Montserrat',
        fontSize: '36px',
        lineHeight: '43.2px',
        letterSpacing: '0.01em',
        display: 'table',
        color: 'black',
        maxWidth: '19ch',
        margin: 0,
        textAlign: 'right',
        fontWeight: '700',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 920)]: {
            maxWidth: '100%',
            textAlign: 'left',
            marginBottom: '10px',
            fontSize: '24px',
            lineHeight: '29px'
        }
    },
    rootClass: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 920)]: {
            justifyContent: 'left'
        }
    },
    p: {
        fontFamily: 'Aktiv Grotesk',
        display: 'table',
        color: 'black',
        fontSize: '1rem',
        fontWeight: '400',
        lineHeight: '22.5px',
        letterSpacing: '0.01em',
        textAlign: 'right',
        margin: 0,
        marginTop: '20px',
        maxWidth: '50ch',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 920)]: {
            maxWidth: '100%',
            textAlign: 'left',
            marginTop: 0,
            marginBottom: '30px'
        }
    },
	caption: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    color: "black",
    fontSize: "14px",
    display: "block",
    fontWeight: "400",
    textAlign: "right",
    lineHeight: "22.5px",
    letterSpacing: "0.01em",
    margin: 0,
    marginTop: "15px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      maxWidth: "100%",
    },
  },
    visible: {
        display: 'block'
    }
})

export default styles